import { useEffect } from 'react';

/**
 * Handle OAuth connector callback params (`?connected=` / `?error=`).
 *
 * The popup lands on the connectors page after the backend redirect.
 * This hook reads the query params, posts the result back to the opener
 * window via postMessage, and closes the popup.
 */
export function useOAuthCallback() {
  useEffect(() => {
    const url = new URL(window.location.href);
    const connected = url.searchParams.get('connected');
    const error = url.searchParams.get('error');

    if (!connected && !error) return;

    const result = {
      type: 'oauth-connect-result' as const,
      connected: connected || undefined,
      error: error || undefined,
      errorDescription: url.searchParams.get('error_description') || undefined,
    };

    if (window.opener) {
      window.opener.postMessage(result, window.location.origin);
      window.close();
      return;
    }

    // Fallback: not in a popup — only clean up connector-specific params.
    // Leave ?error= / ?error_description= so the auth UI can surface them.
    url.searchParams.delete('connected');
    window.history.replaceState({}, '', url.pathname + url.search);
  }, []);
}
